import { Shopflow, LOCK_MEM_TYPE } from './index';
import { useDeviceInfo } from './useDeviceInfo';
import { usePowerRfid } from './usePowerRfid';

export const useWriteRfid = () => {
  const { deviceInfo } = useDeviceInfo();
  const powerRfid = usePowerRfid();

  const lockMem = async (options: { password: string, filterData: string, type: LOCK_MEM_TYPE }) => {
    if (!deviceInfo.value?.isRfidReader) return false;

    await powerRfid.set(powerRfid.powerWrite.value);
    const result = await Shopflow.lockMem(options);
    await powerRfid.set(powerRfid.prevPower.value);

    return result.isLocked;
  }

  const writeData = async (options: { epc: string, password?: string, filterData?: string, filterBank?: number, bank?: number }) => {
    if (!deviceInfo.value?.isRfidReader) return false;

    await powerRfid.set(powerRfid.powerWrite.value);
    const result = await Shopflow.writeRfidData(options);
    await powerRfid.set(powerRfid.prevPower.value);

    return result.isEpcWritten;
  }

  const writePassword = async (options: { password?: string, newPassword?: string, filterData?: string }) => {
    if (!deviceInfo.value?.isRfidReader) return false;
    
    await powerRfid.set(powerRfid.powerWrite.value);
    const result = await Shopflow.writeRfidPassword(options);
    await powerRfid.set(powerRfid.prevPower.value);

    return result.isPasswordWritten;
  }

  return {
    lockMem,
    writeData,
    writePassword,
  }
}
